import { html as o, repeat as s, when as n, slotted as l } from "@microsoft/fast-element";
import { Step as c } from "./step/index.js";
const $ = (a) => {
  const e = o.partial(a.prefix);
  return o`
    <div class="control" part="control">
      <div class="stepper-container">
        <div class="stepper-header">
          <div class="stepper-header-steps">
            ${s(
    (t) => t.steps,
    (t) => o`
                <${e}-step-icon
                  ?active=${(i) => i.active}
                  label=${(i) => i.label}
                  index=${(i) => i.index}
                  status=${(i) => i.status}
                  ?optional=${(i) => i.optional}
                ></${e}-step-icon>
                ${n(
      () => t.orientation == "horizontal",
      o` ${n(
        (i) => i.index !== t.steps.length - 1,
        o` <div class="divider"></div>`
      )}`,
      o` ${n(
        (i) => i.active,
        o` <div
                      class="divider ${(i) => i.index === t.steps.length - 1 ? "divider-hidden" : ""}"
                    ></div>`
      )}`
    )}
              `
  )}
          </div>
        </div>

        <div class="content" part="content">
          <slot
            ${l({
    property: "steps",
    filter: (t) => t instanceof c
  })}
          >
          </slot>
        </div>
      </div>

      <div class="stepper-footer">
        <slot name="footer">
          <div class="footer-buttons-left">
            <${e}-button @click="${(t) => t.handleClickCancel()}" variant="ghost"
            >Cancel
            </${e}-button>
          </div>
          <div class="footer-buttons-right">
            ${n(
    (t) => t.activeStep !== 0,
    o`
                <${e}-button
                  @click="${(t) => t.handleClickBack()}"
                  variant="ghost"
                >
                  <${e}-icon name="arrow-left" slot="start"></${e}-icon>
                  Back
                </${e}-button>`
  )}
            ${n(
    (t) => t.showSkip,
    o`
                <${e}-button
                  @click="${(t) => t.handleClickSkip()}"
                  variant="secondary"
                >
                  <${e}-icon name="chevron-double-right" slot="end"></${e}-icon>
                  Skip to review
                </${e}-button>`
  )}
            ${n(
    (t) => t.isStepBeforeLast,
    o`
                <${e}-button @click="${(t) => t.handleClickSubmit()}">
                  Submit
                </${e}-button>
              `,
    o`
                <${e}-button
                  @click="${(t) => t.handleClickNext()}"
                  variant="primary"
                >
                  <${e}-icon name="arrow-right" slot="end"></${e}-icon>
                    Next${(t) => t.nextLabel ? ": " + t.nextLabel : ""}
                </${e}-button>
              `
  )}
          </div>
        </slot>
      </div>
    </div>
  `;
};
export {
  $ as stepperTemplate
};
